export const CUSTOMER_PRICES_TAB = 'customer-price-tab';
export const CUSTOMER_PRICES_TABLE = 'customer-price-table';
export const ADD_CUSTOMER_PRICE_BUTTON = 'add-customer-price-button';
export const NO_CUSTOMER_PRICES = 'no-customer-prices';
